import * as React from 'react';
import { useState } from 'react';
import { StyleSheet, View } from 'react-native';
import {
  ImageButton,
  TextBox,
  TextBoxProperties
} from 'secullum-react-native-ui';

type Props = TextBoxProperties;

const larguraBotaoExibirSenha = 40;
const espacamentoBotaoExibirSenha = 6;

const TextBoxSenha = ({ style, ...props }: Props) => {
  const [mostrarSenha, setMostrarSenha] = useState(false);

  const {
    margin,
    marginBottom,
    marginEnd,
    marginHorizontal,
    marginLeft,
    marginRight,
    marginStart,
    marginTop,
    marginVertical,
    ...estiloCampo
  } = StyleSheet.flatten([style]);

  const estiloMargens = {
    margin,
    marginBottom,
    marginEnd,
    marginHorizontal,
    marginLeft,
    marginRight,
    marginStart,
    marginTop,
    marginVertical
  };

  return (
    <View style={[styles.container, estiloMargens]}>
      <TextBox
        {...props}
        style={[styles.campoSenha, estiloCampo]}
        secureTextEntry={!mostrarSenha}
      />

      {props.editable !== false && (
        <ImageButton
          icon={mostrarSenha ? 'eye-slash' : 'eye'}
          style={styles.botaoExibirSenha}
          onPress={() => setMostrarSenha(!mostrarSenha)}
          nativeID={props.nativeID ? `${props.nativeID}-exibir` : undefined}
        />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    justifyContent: 'center'
  },
  campoSenha: {
    paddingRight: larguraBotaoExibirSenha + espacamentoBotaoExibirSenha
  },
  botaoExibirSenha: {
    position: 'absolute',
    right: espacamentoBotaoExibirSenha,
    borderWidth: 0
  }
});

export default TextBoxSenha;
